export default __webpack_public_path__ + "static/media/ham.a63ab4de.svg";